<template>
  <div class="home-view">
    <section class="-content">
      <div class="container">
        <h1 class="title-default">Opção de planta</h1>
      </div> <!-- /.container -->
    </section> <!-- /.intro -->

    <section class="plantas">
      <div class="container" v-if="isLoading">
        <h2 class="title-default">Carregando...</h2>
      </div>

      <div class="container" v-if="plantaAlreadySelected">
        <h2>Identificamos que você já selecionou sua planta</h2>

        <form>
          <ul>
            <li>
              <figure>
                <figcaption>
                  <p>
                    <span class="no-input">{{ plantaAlreadySelected.nomePlanta }}</span>
                  </p>
                </figcaption>

                <div>
                  <img :src="getPlantaURL(plantaAlreadySelected.imagemPlanta)" :alt="plantaAlreadySelected.nomePlanta">
                </div>
              </figure>
            </li>
          </ul>
        </form>
      </div>

      <div class="container" v-else-if="!isLoading">
        <form v-if="plantas && plantas.length" @submit.prevent="save">
          <h2>Escolha a sua planta</h2>

          <ul>
            <li v-for="item of plantas" :key="item.id">
              <figure>
                <figcaption>
                  <p>
                    <input type="radio" name="planta" required :value="item.id" v-model="plantSelected" />
                    <span>{{ item.nome }}</span>
                  </p>
                </figcaption>

                <div>
                  <img :src="getPlantaURL(item.imagem)" :alt="item.nome">
                </div>
              </figure>
            </li>
          </ul>

          <button type="submit" class="btn btn-default" :disabled="isSaving" v-if="!saved">
            {{ isSaving ? 'Salvando...' : 'Salvar' }}
          </button>
        </form>

        <h2 v-else>Nenhuma planta encontrada.</h2>

        <h2 v-if="saved">Planta selecionada com sucesso.</h2>
      </div>
    </section> <!-- /.plantas -->
  </div>
</template>

<script>
import Vue from 'vue'
import OpcaoPlantaService from '@/services/OpcaoPlanta'

export default {
  name: 'opcao-planta',

  data () {
    const data = {
      empId: null,
      isLoading: true,
      isSaving: false,
      saved: false,

      plantas: [],
      plantSelected: null,
      urlFiles: Vue.prototype.urlFiles,

      plantaAlreadySelected: null
    }

    return data
  }, // data()

  beforeMount () {
    this.loadPlantaSelecionada()
  }, // beforeMount()

  mounted () {
  }, // mounted()

  methods: {
    async loadPlantaSelecionada () {
      try {
        const { codigoCliente, codigoUsuario, contratoAtual: contrato } = this.$store.state
        const { empreendimentoIdWeb: empId } = contrato

        const { data, ok } = await OpcaoPlantaService.getPlantaSelecionada(codigoCliente, codigoUsuario, empId)

        if (ok && data) {
          this.plantaAlreadySelected = data
          this.isLoading = false

          return
        }

        this.loadList()
      } catch (e) {
        console.error('Erro', e)
      }
    },

    async loadList () {
      try {
        const { empreendimentoIdWeb } = this.$store.state.contratoAtual
        this.empId = empreendimentoIdWeb
        this.plantaAlreadySelected = false

        this.plantas = (await OpcaoPlantaService.getPlantas(this.empId) || []).map(item => ({
          ...item,
          selected: false
        }))

        this.isLoading = false
      } catch (e) {
        console.error('Falha ao recuperar personalizacao', e)
      }
    }, // loadList()

    async save () {
      try {
        if (this.isSaving || this.saved) return

        this.isSaving = true

        const { nome, email, codigoCliente, codigoUsuario, contratoAtual: contrato } = this.$store.state
        const { codigo, bloco, codBloco, unidade, empreendimentoIdMega, empreendimentoIdWeb } = contrato
        const planta = this.plantas.find((item) => item.id === this.plantSelected)

        const model = {
          nomeCliente: nome,
          emailCliente: email,
          codigoCliente,
          codigoUsuario,
          contratoCodigo: codigo,
          contratoCodBloco: codBloco,
          contratoBloco: bloco,
          contratoUnidade: unidade,
          empreendimentoId: empreendimentoIdWeb,
          empreendimentoIdMega,
          nomePlanta: planta.nome,
          imagemPlanta: planta.imagem
        }

        const xhr = await OpcaoPlantaService.save(model)
        this.saved = true
      } catch (e) {
        console.error('Erro!', e)
      } finally {
        this.isSaving = false
      }
    }, // save()

    getPlantaURL (filename) {
      return `${this.urlFiles}/opcao-planta/${filename}`
    } // getPlantaURL()
  }, // methods

  computed: {
  } // computed
}
</script>

<style lang="sass" scoped>
  @import '@/assets/sass/_base.sass'

  section.plantas
    margin-top: -30px

    .container
      max-width: 900px

    h2
      font-family: 'Gotham-Bold'
      text-align: center
      display: block
      font-size: 20px
      margin-bottom: 45px

    button
      max-width: 100px
      margin: 0 auto 20px

    ul
      li
        border: 1px solid map-get($colors, gray)
        border-radius: 10px
        margin-bottom: 30px
        padding: 20px
        background: #fff
        position: relative

        figure
          display: flex
          flex-direction: row
          justify-content: space-between

          figcaption
            p
              input
                position: absolute
                left: 0
                top: 0
                right: 0
                bottom: 0
                width: 100%
                height: 100%
                z-index: 100
                cursor: pointer
                opacity: 0

                &:checked + span:after
                  background: map-get($colors, primary)

              span
                position: relative
                font-size: 22px
                padding-left: 30px
                line-height: 20px
                font-family: 'Gotham-Bold'

                &.no-input
                  &:before,
                  &:after
                    display: none

                &:before,
                &:after
                  content: ''
                  width: 17px
                  height: 17px
                  border-radius: 1px
                  position: absolute
                  left: 0
                  top: 13px
                  transform: translateY(-50%)
                  transition: all 150ms ease

                &:before
                  background: map-get($colors, gray)

                &:after
                  width: 13px
                  height: 13px
                  top: 13px
                  left: 2px

          > div
            img
              max-height: 300px
              max-width: 800px

  @media (max-width: 1024px)
    section.plantas
      ul
        li
          figure
            flex-direction: column

            figcaption
              p
                margin-bottom: 25px

                span
                  font-size: 20px
</style>
